// Fiche de l'assistant : elle lit son onglet de depart dans l'adresse (agentDetailsTab).
// Taches planifiees : du 01/10 au 06/10, l'entree « Taches planifiees » ouvrait cette fiche sur son
// onglet Declencheurs ; depuis le 06/10 (demande de Louka), elle ouvre une vraie page dans le chat
// (front/components/compta/taches/PageTachesPlanifiees.tsx).
export const ONGLETS_FICHE = [
  "info",
  "insights",
  "editors",
  "agent_memory",
  "triggers",
] as const;
export type OngletFiche = (typeof ONGLETS_FICHE)[number];

export function ongletInitialDeLaFiche(valeur: unknown): OngletFiche {
  return typeof valeur === "string" &&
    (ONGLETS_FICHE as readonly string[]).includes(valeur)
    ? (valeur as OngletFiche)
    : "info";
}

export function routeTachesPlanifiees(workspaceId: string): string {
  return `/w/${workspaceId}/taches-planifiees`;
}
